/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_Failure_To_Maintain_Game_StateInputs */



/**
* | output |
* | --- |
* | "Failure to Maintain Game State" |
*
* @param {Sanction_Sub_Failure_To_Maintain_Game_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_failure_to_maintain_game_state = /** @type {((inputs?: Sanction_Sub_Failure_To_Maintain_Game_StateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_Failure_To_Maintain_Game_StateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du Maintien de l'État de Jeu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fallo en Mantener el Estado de Juego")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha em Manter o Estado de Jogo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mancato Mantenimento dello Stato di Gioco")
	return /** @type {LocalizedString} */ ("Failure to Maintain Game State")
});